module.exports = __webpack_public_path__ + "static/media/carservices.11b0ea6a.png";